import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

interface StatusProps {
  label: string;
}

function Status(props: StatusProps) {
  return (
    <Grid
      sx={{
        color:
          props.label === 'OVERDUE'
            ? '#B42318'
            : props.label === 'DUE_TODAY'
            ? '#B54708'
            : props.label === 'UPCOMING_DEADLINE'
            ? '#6C737F'
            : props.label === 'DUE TODAY'
            ? '#B54708'
            : props.label === 'COMPLETED'
            ? '#107569'
            : 'inherit',
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '200%',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        borderRadius: '100px',
        background:
          props.label === 'OVERDUE'
            ? 'rgba(240, 68, 56, 0.12)'
            : props.label === 'DUE_TODAY'
            ? 'rgba(247, 144, 9, 0.12)'
            : props.label === 'UPCOMING_DEADLINE'
            ? 'rgba(17, 25, 39, 0.08)'
            : props.label === 'DUE TODAY'
            ? '#F790091F'
            : props.label === 'COMPLETED'
            ? 'rgba(21, 183, 158, 0.12)'
            : 'inherit',
        textAlign: 'center',
        display: 'inherit',
        padding: '0px 8px',
      }}
    >
      {props.label.replace(/_/g, ' ')}
    </Grid>
  );
}

export default Status;
